import * as React from 'react';
import {Polyline, Marker, Popup, LatLngBounds} from 'react-leaflet';
import * as HistoryModule from 'Modules/HistoryModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {connect} from 'react-redux';
import {
    createArrayOfPoints,
    createArrayOfPointsFromDataFrames,
    LeafletIconCreator,
    DurationComponent,
    DateTimeComponent
} from './../CarDetails/Composites/_CompositesHelpers';
import {generateIconHelperData, getClusterColor} from './../MapHelpers/MapHelpers';
import {CarRideTodaysSummaryDto, PathPoint} from 'Models/HistoryModel';
import CustomCanvasMarkers from './../MapHelpers/CanvasMarkersLayer/CustomCanvasMarkers';
import {getMarkerHtml} from '../MapHelpers/MapHelpers'
import * as L from 'leaflet';
import moment from 'moment';
import i18n from '../../../Translations/_i18n';
import MarkerClusterGroup from "react-leaflet-markercluster";
import ErrorBoundary from "components/Layout/ErrorBoundary";
import * as MapModule from "Modules/MapModule";

type Props = {}
type ConnectedProps = {
  historyStore: HistoryModule.Types.HistoryStore;
  viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
  vehiclesStore: VehiclesModule.Types.VehiclesStore;
  map: MapModule.Types.MapStore
};

type State = {};

class HistoryRides extends React.Component<Props & ConnectedProps, State> {
    constructor(props: Props & ConnectedProps) {
        super(props);
    }

    public render() {
        const {carRidesHistorySummary, carTodaysRide, carRideDetails} = this.props.historyStore;
        const {TODAYS, LIST, DETAILS} = HistoryModule.EnumTypes.RideViewType;
        const {viewManagementStore, vehiclesStore} = this.props;
        return (
            <div className="historyRides">
                {viewManagementStore.activeRideView === TODAYS && <TodaysRide ride={carTodaysRide}/>}
                {viewManagementStore.activeRideView === LIST &&
                <HistorySummaryRides carRidesHistorySummary={carRidesHistorySummary}/>}
                {viewManagementStore.activeRideView === DETAILS &&
                <DetailsRide
                  carRideDetails={carRideDetails}
                  activeCar={vehiclesStore.activeVehicleDetails}
                  shouldShowDirectionsOnTrack={
                    this.props.map?.minZoomToShowDirectionsOnTrack !== undefined
                    && this.props.map?.zoom !== undefined
                    && (this.props.map?.zoom > this.props.map?.minZoomToShowDirectionsOnTrack)
                  }
                />}
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        historyStore: state.historyStore,
        viewManagementStore: state.viewManagementStore,
        vehiclesStore: state.vehiclesStore,
        map: state.mapStore
    };
}

export default connect(mapStateToProps)(HistoryRides) as React.ComponentClass<Props>;

export const TodaysRide = (props: { ride: CarRideTodaysSummaryDto }) => {
    const {ride} = props;
    if (ride) {
        return (
            <>
                {ride.path.length > 0 &&
                <Polyline className={'todays_polyline'} positions={createArrayOfPointsFromDataFrames(ride.path)}/>}
                {ride.parkings.length > 0 &&
                ride.parkings.map((e, idx) => (
                    <Marker key={`todays_parkings-${idx}`} position={{lat: e.point.latitude, lng: e.point.longitude}}
                            icon={LeafletIconCreator('images/icons/parking_sign.svg')}/>
                ))}
            </>
        );
    } else {
        return null;
    }
};

const createClusterCustomIcon = function (cluster: L.MarkerCluster) {
    return L.divIcon({
        html: `<div class="count-container">
                    <img class="car-ImgEl" src="/images/icons/stop_sign.svg">
                    <span class="count-container__count-value">${cluster.getChildCount()}</span>
               </div>`,
        className: `marker-cluster__stop-sign`,
        iconSize: L.point(40, 40, true)
    });
};

const HistorySummaryRides = (props: { carRidesHistorySummary: HistoryModule.Types.CarRidesHistorySummaryResponse }) => {
    const {carRidesHistorySummary} = props;

    if (carRidesHistorySummary) {
        return (
            <MarkerClusterGroup iconCreateFunction={createClusterCustomIcon}>
                {carRidesHistorySummary.rides.map((e, idx) => {
                    const polylinePositions = createArrayOfPoints(e.path);
                    return (
                        <span key={idx}>
                            <Polyline className={'polyline'} key={`summary_polyline-${e.id}`}
                                      positions={polylinePositions}/>
                            {e.stops.map((stopEl, i) => {
                                const startDate = moment(stopEl.startDate);
                                const html = `
                                <p class="vehicle-icon__title activeCar">
                                    <span class="car-Name">${startDate.format("HH:mm:ss")}</span></br>
                                    <span class="car-DeviceId">${startDate.format("DD.MM.YYYY")}</span>
                                </p> 
                                <div class="car-Img"><img class="car-ImgEl" src="/images/icons/stop_sign.svg"></div>`;

                                const Icon = L.divIcon({
                                    iconUrl: '/images/icons/stop_sign.svg',
                                    iconSize: [25, 25],
                                    html,
                                    className: `vehicle-icon vehicle-icon--hover`
                                });

                                return (
                                    <Marker
                                        key={`summary_stop-${i}`}
                                        position={{lat: stopEl.point.latitude, lng: stopEl.point.longitude}}
                                        icon={Icon}/>
                                );
                            })}
                        </span>
                    );
                })}
                {carRidesHistorySummary.parkings.map((e, idx) => {
                    const startDate = moment(e.startDate);
                    const html = `
                        <p class="vehicle-icon__title activeCar">
                            <span class="car-Name">${startDate.format("HH:mm:ss")}</span></br>
                            <span class="car-DeviceId">${startDate.format("DD.MM.YYYY")}</span>
                        </p> 
                        <div class="car-Img"><img class="car-ImgEl" src="/images/icons/parking_sign.svg"></div>`;

                    const Icon = L.divIcon({
                        iconUrl: '/images/icons/stop_sign.svg',
                        iconSize: [25, 25],
                        html,
                        className: `vehicle-icon vehicle-icon--hover`
                    });
                    return <Marker
                        key={`summary_stop-${idx}`}
                        position={{lat: e.point.latitude, lng: e.point.longitude}}
                        icon={Icon}/>;
                })}
            </MarkerClusterGroup>
        );
    } else {
        return null;
    }
};
type DetailsRideP = {
    carRideDetails: HistoryModule.Types.CarRideDetailsResponse;
    activeCar: VehiclesModule.Types.CarDto;
    shouldShowDirectionsOnTrack: boolean
};
type DetailsRideS = {
    popupVisible: boolean;
    pathPointDetails: VehiclesModule.Types.CarDataframeDto;
    isStop: boolean;
    carStopDto: HistoryModule.Types.CarRideStopDto;
};

class ParentRide<P, S extends DetailsRideS> extends React.Component<P, S> {
    constructor(props: P) {
        super(props);
        this.managePopup = this.managePopup.bind(this);
    }

    protected managePopup(pathPointDetails: VehiclesModule.Types.CarDataframeDto, isStop: boolean = false, carStopDto: HistoryModule.Types.CarRideStopDto = null) {
        this.setState(
            {
                popupVisible: false,
                pathPointDetails,
                isStop,
                carStopDto
            },
            () => this.setState({popupVisible: true})
        );
    }
}

class DetailsRide extends ParentRide<DetailsRideP, DetailsRideS> {
    constructor(props: DetailsRideP) {
        super(props);
        this.state = {
            popupVisible: false,
            pathPointDetails: null,
            isStop: false,
            carStopDto: null
        };
    }

    public render() {
        const {carRideDetails, activeCar} = this.props;
        const {popupVisible, pathPointDetails, carStopDto, isStop} = this.state;
        if (carRideDetails) {
            return (
                <>
                    <Polyline className={'details_polyline'}
                              positions={createArrayOfPointsFromDataFrames(carRideDetails.path)}/>
                    {carRideDetails.path.map((singlePathPoint, idx) => {
                        const position = {lat: singlePathPoint.latitude, lng: singlePathPoint.longitude};
                        if (idx === 0) {
                            return (
                                <Marker
                                    onClick={() => this.managePopup(singlePathPoint)}
                                    key={`start_ride_pathpoint-${idx}`}
                                    position={position}
                                    icon={LeafletIconCreator('images/icons/ride_start.svg')}
                                />
                            );
                        }
                        if (idx === carRideDetails.path.length - 1) {
                            return (
                                <Marker onClick={() => this.managePopup(singlePathPoint)}
                                        key={`end_ride_pathpoint-${idx}`}
                                        position={position} icon={LeafletIconCreator('images/icons/ride_end.svg')}/>
                            );
                        }

                        if (this.props.shouldShowDirectionsOnTrack) {
                          return  (
                            <Marker
                              onClick={() => this.managePopup(singlePathPoint)}
                              key={`details_pathpoint-${idx}`}
                              position={position}
                              icon={LeafletIconCreator('images/icons/ride_direction.svg', singlePathPoint.heading | 0, {
                                x: 26,
                                y: 30
                              })}
                            />
                          )
                        }

                        return null
                    })}
                    {carRideDetails.stops.map((stopEl, idx) => {
                        return (
                            <Marker
                                onClick={() => this.managePopup(null, true, stopEl)}
                                key={`details_stop-${idx}`}
                                position={{lat: stopEl.point.latitude, lng: stopEl.point.longitude}}
                                icon={LeafletIconCreator('/images/icons/stop_sign.svg')}
                            />
                        );
                    })}
                    {popupVisible && (
                        <>{isStop ? <PopupStopDetails carStopDto={carStopDto} activeCar={activeCar}/> :
                            <PopupPathPointDetails pathPointDetails={pathPointDetails} activeCar={activeCar}/>}</>
                    )}
                </>
            );
        }
        return <div>error</div>
    }
}

const PopupPathPointDetails = (props: { pathPointDetails: VehiclesModule.Types.CarDataframeDto; activeCar: VehiclesModule.Types.CarDto }) => {
    const {pathPointDetails, activeCar} = props;
    const {GREY} = VehiclesModule.EnumTypes.VehicleSpeedEnum;

    const iconHelper: VehiclesModule.Types.IconHelper = generateIconHelperData(activeCar.carCategory, GREY);
    return (
        <Popup className="pathpoint_popup_details"
               position={{lat: pathPointDetails.latitude, lng: pathPointDetails.longitude}} autoPan={false}>
            <div className="pathpoint_popup_details__icon">
                <img src={iconHelper.imageUrl} width={20}/>
            </div>
            <div className="pathpoint_popup_details__data">
                <DateTimeComponent date={pathPointDetails.dateTime}/>
                <p className="font-sm">
                    <span className="font-bold">
                        {activeCar.vin} [{activeCar.deviceId}]
                    </span>
                </p>
                <p className="font-sm">
                    <span className="font-grey-light">{i18n.t('carDetails:speedGps')}</span> <span
                    className="font-bold">{pathPointDetails.speedGps} km/h</span>
                </p>
                <p className="font-sm">
                    <span className="font-grey-light">{i18n.t('carDetails:mileage')}</span> <span
                    className="font-bold ">{pathPointDetails.mileageGps} km</span>
                </p>
                {/* <p className="font-sm">
                    <span className="font-grey-light">Paliwo</span> <span className="font-bold">Brak danych</span>
                </p> */}
            </div>
        </Popup>
    );
};

const PopupStopDetails = (props: { carStopDto: HistoryModule.Types.CarRideStopDto; activeCar: VehiclesModule.Types.CarDto }) => {
    const {carStopDto, activeCar} = props;
    const {GREY} = VehiclesModule.EnumTypes.VehicleSpeedEnum;
    const iconHelper: VehiclesModule.Types.IconHelper = generateIconHelperData(activeCar.carCategory, GREY);

    return (
        <Popup className="pathpoint_popup_details"
               position={{lat: carStopDto.point.latitude, lng: carStopDto.point.longitude}}>
            <div className="pathpoint_popup_details__icon">
                <img src={iconHelper.imageUrl} width={20}/>
            </div>
            <div className="pathpoint_popup_details__data">
                <p>
                    <DateTimeComponent date={carStopDto.startDate}/>
                </p>
                <p className="font-sm">
                    <span className="font-grey-light">{i18n.t('carDetails:duration')}</span>
                    <span className="font-bold">
                        <DurationComponent inline durationSeconds={carStopDto.durationSeconds}/>
                    </span>
                </p>
                <p className="font-sm">
                    <span className="font-grey-light">{i18n.t('carDetails:address')}: </span>
                    <span className="font-bold">
                    {carStopDto.address ? carStopDto.address : i18n.t('carDetails:noDataTitle')}
                    </span>
                </p>
            </div>
        </Popup>
    );
};

interface LatestDataframeRidesP {
    latestDataframes: Array<VehiclesModule.Types.CarDataframeDto>;
    activeCar: VehiclesModule.Types.CarDto;
    mapRef: L.Map;
    componentMapRef: any;
}

export class LatestDataframeRides extends ParentRide<LatestDataframeRidesP, DetailsRideS> {
    private polygonRef: any;

    constructor(props: LatestDataframeRidesP) {
        super(props);
        this.state = {
            popupVisible: false,
            pathPointDetails: null,
            isStop: false,
            carStopDto: null
        };
        this.accessDataframe = this.accessDataframe.bind(this);
        this.managePopup = this.managePopup.bind(this);
        this.onAdd = this.onAdd.bind(this);
    }

    private accessDataframe(e: any, dataframe: VehiclesModule.Types.CarDataframeDto) {
        this.managePopup(dataframe);
    }

    public componentDidUpdate() {
        if (this.polygonRef && this.polygonRef.leafletElement && this.polygonRef.leafletElement._bounds) {
            this.props.mapRef.fitBounds(this.polygonRef.leafletElement._bounds);
        }
    }

    public shouldComponentUpdate(nextProps: LatestDataframeRidesP, nextState: DetailsRideS) {
        if (JSON.stringify(nextProps.latestDataframes) !== JSON.stringify(this.props.latestDataframes)) {
            return true;
        }
        if (nextState.popupVisible !== this.state.popupVisible) {
            return true;
        }
        return false;
    }

    private onAdd(element) {
        this.props.mapRef.fitBounds(element.target._bounds);
    }

    public render() {
        const {latestDataframes, activeCar} = this.props;
        const {popupVisible, pathPointDetails, carStopDto, isStop} = this.state;
        return (
            <>
                {latestDataframes.length > 0 && (
                    <Polyline className={'details_polyline'}
                              positions={createArrayOfPointsFromDataFrames(latestDataframes)} onadd={this.onAdd}
                              ref={ref => (this.polygonRef = ref)}/>
                )}
                <CustomCanvasMarkers
                  componentMapRef={this.props.componentMapRef}
                  mapRef={this.props.mapRef}
                  latestDataframes={latestDataframes}
                  onMarkerClick={this.accessDataframe}
                />
                {popupVisible && (
                    <>{isStop ? <PopupStopDetails carStopDto={carStopDto} activeCar={activeCar}/> :
                        <PopupPathPointDetails pathPointDetails={pathPointDetails} activeCar={activeCar}/>}</>
                )}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Map/History/HistoryRides.tsx